import { Switch } from "@/components/ui/switch";
import { Card } from "@/components/ui/card";
import { useFeatureFlag, useToggleFeatureFlag } from "@/hooks/useFeatureFlag";
import { toast } from "@/hooks/use-toast";
import { Eye, EyeOff } from "lucide-react";

export function AcademyFeatureToggle() {
  const { isEnabled, updatedAt, isLoading } = useFeatureFlag("academy_enabled");
  const toggle = useToggleFeatureFlag("academy_enabled");

  const handleChange = async (next: boolean) => {
    try {
      await toggle.mutateAsync(next);
      toast({
        title: next ? "Academy visível para candidatos" : "Academy oculto para candidatos",
        description: next
          ? "Os candidatos agora veem o Academy no menu."
          : "Apenas administradores veem o Academy.",
      });
    } catch (e: any) {
      toast({
        title: "Erro ao atualizar",
        description: e.message ?? "Tente novamente.",
        variant: "destructive",
      });
    }
  };

  return (
    <Card className="p-4 flex items-center justify-between gap-4">
      <div className="flex items-start gap-3">
        {isEnabled ? (
          <Eye className="h-5 w-5 text-primary mt-0.5" />
        ) : (
          <EyeOff className="h-5 w-5 text-muted-foreground mt-0.5" />
        )}
        <div>
          <p className="font-medium text-sm">Exibir Academy para candidatos</p>
          <p className="text-xs text-muted-foreground">
            Quando desligado, apenas administradores enxergam o Academy no menu e podem acessar a rota.
          </p>
          {updatedAt && (
            <p className="text-[11px] text-muted-foreground mt-1">
              Última alteração: {new Date(updatedAt).toLocaleString("pt-BR")}
            </p>
          )}
        </div>
      </div>
      <Switch
        checked={isEnabled}
        onCheckedChange={handleChange}
        disabled={isLoading || toggle.isPending}
      />
    </Card>
  );
}
